<div class="error-page-wrapper tui-space_vertical-4 tui-space_left-8 tui-space_right-7">
  <ng-container *ngIf="errorPageMessage$ | async as errorPageMessage">
    <ng-container *ngIf="errorPageMessage.severity === 'error'">
      <tui-notification class="notification-wrapper" status="error">
        <span class="ait-font-text-m" [innerHTML]="errorPageMessage.message"></span>
      </tui-notification>
    </ng-container>

    <ng-container *ngIf="errorPageMessage.severity === 'warn'">
      <tui-notification class="notification-wrapper" [hasIcon]="false" status="warning">
        <span class="ait-font-text-xl tui-space_right-2">☝️</span>
        <span class="ait-font-text-m" [innerHTML]="errorPageMessage.message"></span>
      </tui-notification>
    </ng-container>
  </ng-container>
</div>
